import { useMemo } from 'react';
import { useAuthStore } from '../store/auth-store';
import { getCurrentDateTime, secondsToDateTime } from '../utils';

export const useAuth = () => {
  // TODO: Change to auth.accessToken from auth.idToken when
  // backend API already addressed the token mismatch issue.
  const accessToken = useAuthStore((state) => state.idToken);
  const email = useAuthStore((state) => state.idToken.payload.email);
  const scope = useAuthStore((state) => state.accessToken.payload.scope);
  const signIn = useAuthStore((state) => state.signIn);
  const signOut = useAuthStore((state) => state.signOut);

  const isTokenValid = useMemo(() => {
    const { exp } = accessToken.payload;
    if (!exp) {
      return false;
    }
    const now = getCurrentDateTime();
    const expiry = secondsToDateTime(exp);
    return expiry > now;
  }, [accessToken]);

  const isAuthenticated = useMemo(() => (
    Boolean(accessToken.jwtToken && isTokenValid)
  ), [accessToken, isTokenValid]);

  return {
    accessToken,
    email,
    isTokenValid,
    isAuthenticated,
    scope,
    signIn,
    signOut,
  };
};
